import React from 'react';
import { Typography, Tag } from 'antd';
import {
    CarOutlined,
    RocketOutlined,
    ClockCircleOutlined,
    ShopOutlined,
    InboxOutlined
} from '@ant-design/icons';
import './ShippingMethodCard.css';

interface ShippingMethodCardProps {
    id: number;
    name: string;
    imageUrl?: string;
    price?: string; // Formatted price
    description?: string;
    isSelected: boolean;
    onClick: () => void;
    disabled?: boolean;
    isToAgree?: boolean;
}

export const ShippingMethodCard: React.FC<ShippingMethodCardProps> = ({
    name,
    imageUrl,
    price,
    isSelected,
    onClick,
    disabled = false,
    isToAgree = false
}) => {

    // Función para obtener icono fallback según el nombre o tipo
    const getFallbackIcon = (methodName: string) => {
        const lowerName = methodName.toLowerCase();
        if (lowerName.includes('moto') || lowerName.includes('express')) return <RocketOutlined />;
        if (lowerName.includes('correo') || lowerName.includes('postal')) return <InboxOutlined />;
        if (lowerName.includes('tienda') || lowerName.includes('retiro')) return <ShopOutlined />;
        if (isToAgree) return <ClockCircleOutlined />;
        return <CarOutlined />;
    };

    return (
        <div
            className={`shipping-method-card ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => !disabled && onClick()}
            role="radio"
            aria-checked={isSelected}
            tabIndex={disabled ? -1 : 0}
        >
            <div className="shipping-method-icon">
                {imageUrl ? (
                    <img src={imageUrl} alt={name} className="shipping-method-img" />
                ) : (
                    <span className="shipping-method-fallback-icon">
                        {getFallbackIcon(name)}
                    </span>
                )}
            </div>

            <div className="shipping-method-details">
                <Typography.Text className={`shipping-method-name`} ellipsis>
                    {name}
                </Typography.Text>

                {price && !isToAgree && (
                    <Typography.Text className={`shipping-method-price ${isSelected ? '' : 'text-success'}`} strong>
                        {price}
                    </Typography.Text>
                )}

                {isToAgree && (
                    <Tag color={isSelected ? "blue" : "gold"} className="shipping-method-tag">A Convenir</Tag>
                )}
            </div>

            {isSelected && <div className="shipping-selection-indicator" />}
        </div>
    );
};
